export const debounce = (fn: any, wait: number) => {
  let t

  return (...args) => {
    clearTimeout(t)

    t = setTimeout(() => fn.apply(this, args), wait)
  }
}
